import { IoIosClose } from "react-icons/io";
import { MoonLoader } from "react-spinners";
import { useModalDeleteCliente } from "./modalDeleteClienteHooks";
import type { ModalDeleteClienteProps } from "./types";

export const ModalDeleteCliente = (props: ModalDeleteClienteProps) => {
  const modalState = useModalDeleteCliente(props);

  if (!modalState) {
    return null;
  }

  const { deleteCliente, handleClose, isDeleting, selectedCliente } = modalState;

  return (
    <div className="w-full min-h-screen h-screen z-20 bg-black bg-opacity-50 px-2 md:px-8 flex justify-center items-center fixed top-0 left-0">
      <div className="bg-gray-200 w-[400px] p-4 rounded-md relative max-h-[90%] overflow-y-auto text-sm">
        <div className="absolute right-2 top-2 cursor-pointer bg-white rounded-[50%] p-[1px]">
          <IoIosClose size={40} onClick={handleClose} />
        </div>

        <p className="text-center font-semibold text-base mt-8 text-red-600">
          Al eliminar este cliente perdera todos los datos relacionados con el
          mismo.
        </p>
        <p className="text-center font-semibold text-lg">
          Esta seguro que desea eliminar al Cliente{" "}
          {selectedCliente.nombreCliente}?
        </p>

        <div className="flex w-full justify-between mt-2">
          <button
            type="button"
            className="bg-red-500 text-lg font-semibold mt-2 w-fit text-white px-2 py-1 rounded-md flex justify-center items-center min-w-[80px]"
            onClick={deleteCliente}
            disabled={isDeleting}
          >
            {isDeleting ? <MoonLoader size={20} color="#ffffff" /> : "Eliminar"}
          </button>

          <button
            type="button"
            className="bg-gray-500 text-lg font-semibold mt-2 w-fit text-white px-2 py-1 rounded-md flex justify-center items-center min-w-[80px]"
            onClick={handleClose}
            disabled={isDeleting}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};
